import React, { useEffect, useState } from "react";

const StickyBetaButton = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      className={`lg:hidden fixed bottom-0 inset-x-0 z-40 p-4 bg-gradient-to-t from-[#050A12] via-[#050A12]/95 to-transparent transition-all duration-300 ${
        show ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
    >
      <a
        href="#beta"
        className="btn-emerald block text-center bg-[#10C98A] text-[#050A12] font-semibold py-4 rounded-full"
      >
        Join the Renn Beta
      </a>
    </div>
  );
};

export default StickyBetaButton;
